import { message } from 'antd'

import { dispatchGlobalEvent } from '@hooks/useGlobalEvent'
import { request } from '@utils/request'

import {
  AddWishType,
  AlsoViewType,
  MatchList,
  PageData,
  RemoveWishType,
  WishListType
} from './types'

/**
 * 商品详情页
 * @param products_id  1
 * @param products_sku
 * @param products_sku_id 171
 */
const getDetail = async (id: string, params = {}, customUrl = null) => {
  return request
    .get<PageData>(customUrl || '/product/getProductInfo', {
      products_sku_id: id,
      ...params
    })
    .then((res) => {
      return res.data as PageData
    })
    .catch((err) => {
      // message.error(`Failure! ${err?.message}`)
      throw new Error(err)
    })
}

/**
 * 商品推荐
 */
const getRecommend = async (params?: Type.DefineObject) => {
  return request.get('/product/recommend', params).then((res) => {
    return res.data
  })
}

/**
 * 获取商品集合
 */
const getCollection = async (params?: Type.DefineObject) => {
  return request.get('product/collection', params).then((res) => {
    return res.data
  })
}

/**
 * 商品alsoView
 * @types-AlsoView
 * getAlsoView created by AlsoView api
 */
export const getAlsoView = (params: {
  productsSkuId: string | number
  page_size?: number
}) => {
  return request
    .get<AlsoViewType>('/product/getAlsoView', params)
    .then((res) => {
      return res.data
    })
}
/* @types-AlsoView */

export { getDetail, getRecommend, getCollection }

/**
 * 添加收藏
 * @types-AddWish
 * postAddWish created by AddWish api
 */
export const postAddWish = (params: {
  skuId: string
  isRemoveCart: string | number
}) => {
  return request.post<AddWishType>('/customers/addWish', params).then((res) => {
    return res
  })
}
/* @types-AddWish */
/**
 * 取消收藏
 * @types-RemoveWish
 * postRemoveWish created by RemoveWish api
 */
export const postRemoveWish = (params: { skuId: string }) => {
  return request
    .post<RemoveWishType>('/customers/removeWish', params)
    .then((res) => {
      return res
    })
}
/* @types-RemoveWish */
/**
 * 收藏列表
 * @types-WishList
 * getWishList created by WishList api
 */
export const getWishList = (params: {
  page: number
  pageSize: number
  sort: string
  url_path?: string
}) => {
  return request
    .get<WishListType>('/customers/wishList', params)
    .then((res) => {
      return res
    })
}
/* @types-WishList */

/**
 * 获取PerfectMatch商品列表
 */
export const getPerfectMatch = (products_sku_id) => {
  return request
    .get('/product/getProductMatchShopping', { products_sku_id })
    .then((res) => res.data?.matchList as MatchList[])
}

/**
 * 获取postcode
 */
export const getPostCodeInfo = () => {
  return request
    .get('/customers/getPostcodeInfo', {})
    .then((res) => res.data as { postcode; city })
}

/**
 * 设置postcode
 */
export const setPostCodeInfo = (postcode: string) => {
  return request
    .post('/customers/setPostcode', { postcode })
    .then((res) => {
      if (res.code === 200) {
        message.success('Successful')
        dispatchGlobalEvent('detailRefetch')
        // dispatchGlobalEvent('shopCartListRefetch')
        return { isValid: true }
      }
      return { isValid: false, message: res.message }
    })
    .catch((error) => {
      return { isValid: false, message: error.message }
    })
}
